{
  "name": "rb-dashboard",
  "version": "3.2.2",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "install:clean": "rm -rf node_modules/ && rm -rf package-lock.json && npm install && ng serve -o",
    "deploy": "npx gulp release:prod",
    "deploy:auto": "npx gulp release:prod"
  },
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0",
    "npm": ">=10.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.21",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.21",
    "@angular/compiler": "21.2.21",
    "@angular/core": "21.2.21",
    "@angular/elements": "21.2.21",
    "@angular/forms": "21.2.21",
    "@angular/localize": "21.2.21",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.21",
    "@angular/platform-browser-dynamic": "21.2.21",
    "@angular/platform-server": "21.2.21",
    "@angular/router": "21.2.21",
    "@angular/service-worker": "^21.2.21",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angular-cd-timer": "^3.0.0",
    "arrive": "2.5.2",
    "bootstrap": "5.3.8",
    "bootstrap-material-design": "4.1.3",
    "bootstrap-notify": "3.1.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.0.0",
    "classlist.js": "1.1.20150312",
    "core-js": "3.41.0",
    "jquery": "3.6.0",
    "moment": "2.30.1",
    "moment-timezone": "^0.5.34",
    "momentjs": "^2.0.0",
    "ngx-moment": "^6.0.2",
    "perfect-scrollbar": "1.5.6",
    "popper.js": "1.16.1",
    "rxjs": "^7.5.5",
    "rxjs-compat": "6.6.7",
    "web-animations-js": "2.3.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.21",
    "@angular/cli": "21.2.21",
    "@angular/compiler-cli": "21.2.21",
    "@angular/language-service": "21.2.21",
    "@types/bootstrap": "5.2.10",
    "@types/chart.js": "^2.9.36",
    "@types/chartjs-plugin-colorschemes": "^0.4.7",
    "@types/gapi": "^0.0.47",
    "@types/gapi.auth2": "^0.0.61",
    "@types/google.maps": "3.58.1",
    "@types/jasmine": "~3.10.3",
    "@types/jquery": "3.5.6",
    "@types/node": "22.17.1",
    "gulp": "^5.0.1",
    "gulp-zip": "^6.1.0",
    "jasmine-core": "~4.0.1",
    "karma": "^6.3.17",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "^2.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~4.0.1",
    "karma-jasmine-html-reporter": "^1.7.0",
    "sass": "1.98.0",
    "ts-node": "~10.9.2",
    "tslint": "6.1.3",
    "typescript": "~5.9.3"
  }
}
